import { amountAsCurrency, Currency } from "currency";
import { FlatList } from "react-native";
import { List, useTheme, Text, Divider } from "react-native-paper";
import { useTailwind } from "tailwind-rn";

import { Carriers } from "../../../../logos";
import InfoText from "../../components/InfoText";
import { FulfillmentOption } from "../../types";

type Props = {
  filteredOptions: FulfillmentOption[];
};
export default function DeliveryOptions({ filteredOptions }: Props) {
  const tailwind = useTailwind();
  const { colors } = useTheme();

  if (!filteredOptions.length) return null;

  return (
    <FlatList
      data={filteredOptions}
      bounces={false}
      style={tailwind("flex-1 -mx-4")}
      ListHeaderComponent={
        <InfoText
          title="Tarifas de envío"
          style={{ backgroundColor: colors.surface }}
        />
      }
      contentContainerStyle={tailwind("mx-4")}
      stickyHeaderIndices={[0]}
      renderItem={({ item }) => (
        <List.Item
          title={<Carriers.Logotype carrier={item.carrier_name} width={100} />}
          description={item.description}
          right={() => (
            <PriceLabel amount={item.price} currency={item.currency} />
          )}
        />
      )}
      ItemSeparatorComponent={Divider}
    />
  );
}

function PriceLabel({
  amount,
  currency,
}: {
  amount: number;
  currency: Currency;
}) {
  const tailwind = useTailwind();
  const { colors } = useTheme();
  const color = colors.onSurfaceVariant;

  return (
    <Text variant="bodySmall" style={[tailwind("self-center"), { color }]}>
      {amount === 0 ? "Gratis" : amountAsCurrency({ amount, currency })}
    </Text>
  );
}
